module.exports = __webpack_public_path__ + "static/media/pyramid_blue_small.74223ee0.jpg";